// Cross-links between Labs (hands-on) and University (concepts), so the two
// stop being parallel silos: each lab points at the article that explains its
// concept, and each of those articles points back at the lab to try it.
//
// Keyed by Lab `id` (the stable internal id, not the display order) → the
// University article `id` that best explains that lab's core concept.
export const LAB_TO_ARTICLE = {
  1: 'au-1',   // Hello Collection            → How automations work
  2: 'au-4',   // Auto-Status Update          → Action Node — do the work
  24: 'ts-1',  // Build it yourself           → My automation didn't run — checklist
  3: 'au-3',   // Condition Branching         → Condition Node — branching logic
  4: 'nt-1',   // Task Queue & Inbox          → Function Node — team & task queue
  5: 'bp-1',   // Full Pipeline — End to End  → Designing effective pipelines
  6: 'cn-1',   // Social Media — Connectors   → How connections work
  7: 'ts-2',   // Reading Pipeline Logs       → Reading the Logs page
  8: 'au-4',   // Send Message                → Action Node — do the work
  20: 'api-1', // Connect via the REST API    → Getting started with the API
  21: 'wt-1',  // Invite your team & roles    → Roles & permissions
  22: 'wt-3',  // Read your Knowledge Base     → Knowledge Base
  23: 'pb-1',  // Your first AI agents        → What makes a great playbook
};

// Reverse map: each article → the first lab (lowest id) that teaches it, so an
// article links to a single, unambiguous "try it" lab.
export const ARTICLE_TO_LAB = Object.entries(LAB_TO_ARTICLE)
  .sort((a, b) => Number(a[0]) - Number(b[0]))
  .reduce((acc, [labId, articleId]) => {
    if (!(articleId in acc)) acc[articleId] = Number(labId);
    return acc;
  }, {});
